import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Primary, Secondary, Text } from "@cinch-labs/design-system";
import { interpolateI18n } from "@cinch-labs/shared-util";
import React, { useEffect } from "react";
import styles from "../../return-to-checkout-modal.module.css";
import { ModalState } from "../../return-to-checkout-modal.types";
import { VehicleInformation } from "../../vehicle-information/vehicle-information.component";
import classNames from "classnames";
var formatTime = function(timeInSeconds) {
    if (timeInSeconds < 60) {
        return "".concat(timeInSeconds, " seconds");
    }
    var minutes = Math.floor(timeInSeconds / 60);
    var seconds = timeInSeconds % 60;
    var formattedSeconds = seconds < 10 ? "0".concat(seconds) : seconds;
    return "".concat(minutes, ":").concat(formattedSeconds, " minutes");
};
export var ReturnToCheckoutExpiringSoon = function(param) {
    var vehicle = param.vehicle, onButtonClick = param.onButtonClick, onSecondaryButtonClick = param.onSecondaryButtonClick, timeRemainingInSeconds = param.timeRemainingInSeconds, title = param.title, isButtonLoading = param.isButtonLoading, isSecondaryButtonLoading = param.isSecondaryButtonLoading, i18n = param.i18n, adminFeeFlag = param.adminFeeFlag, adminFeeValueInPence = param.adminFeeValueInPence, trackEvent = param.trackEvent, noOpTracking = param.noOpTracking, onModalOpen = param.onModalOpen;
    useEffect(function() {
        onModalOpen(ModalState.expiringSoon);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.contentWrapper,
        children: [
            title,
            /*#__PURE__*/ _jsx(Text, {
                className: classNames(styles.cardText, styles.remainingTimeText),
                fontWeight: "light",
                fontSize: "s",
                children: interpolateI18n(i18n.text, {
                    timeRemaining: formatTime(timeRemainingInSeconds)
                }, {
                    bold: function(t) {
                        return /*#__PURE__*/ _jsx(Text, {
                            fontWeight: "semibold",
                            fontSize: "s",
                            className: styles.subheader,
                            children: t
                        }, t);
                    }
                })
            }),
            /*#__PURE__*/ _jsx(VehicleInformation, {
                vehicle: vehicle,
                adminFeeFlag: adminFeeFlag,
                adminFeeValueInPence: adminFeeValueInPence,
                trackEvent: trackEvent,
                noOpTracking: noOpTracking
            }),
            /*#__PURE__*/ _jsx(Primary, {
                isLoading: isButtonLoading,
                onClick: onButtonClick,
                size: "large",
                isFullWidth: true,
                children: i18n.buttonText
            }),
            /*#__PURE__*/ _jsx(Secondary, {
                classNames: {
                    button: styles.button
                },
                isLoading: isSecondaryButtonLoading,
                disabled: isSecondaryButtonLoading,
                onClick: onSecondaryButtonClick,
                size: "large",
                isFullWidth: true,
                children: i18n.secondaryButtonText
            })
        ]
    });
};
